var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 34.4H0V43H7.4V34.4Z",
    fill: "#51DCA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 28H9.9V43H17.3V28Z",
    fill: "#51DCA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 22H19.7V43H27.1V22Z",
    fill: "#51DCA8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16H29.6V43H37V16Z",
    fill: "#51DCA8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9 10H39.5V43H46.9V10Z",
    fill: "#51DCA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.9a41a4d3ab4d496050d0438a95aa26a6.svg";
export { ForwardRef as ReactComponent };